// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { locationSearchFormStyles } from "@steiner/Overrides/Components/LocationSearchForm";
import { css } from "styled-components";

locationSearchFormStyles.form = {
    css: css`
        width: 100%;
        padding: 15px;
    `,
};

locationSearchFormStyles.searchContainer = {
    css: css`
        display: grid;
    `,
};

locationSearchFormStyles.searchGeoLocationGridItem = {
    width: [12, 12, 12, 6, 6],
};

locationSearchFormStyles.searchLocationsGridItem = {
    width: [12, 12, 12, 6, 6],
};

locationSearchFormStyles.searchRadiusGridItem = {
    width: [12, 12, 12, 6, 6],
};

locationSearchFormStyles.searchButtonGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        padding-top: 10px;
        display: inline-block;
        width: 100%;
        flex-direction: row;
        text-align: right;
        align-self: flex-end;
        & > div {
            display: inline-flex;
        }
    `,
};

locationSearchFormStyles.clearButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};
